module.exports = __webpack_public_path__ + "distribution/img/task.32fdc1df.gif";